import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString1pkumu07cwy4m as toString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  RuntimeException1r3t0zl97011n as RuntimeException,
  VOID7hggqo3abtya as VOID,
  captureStack1fzi4aczwc4hg as captureStack,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instanceat14thlj150z as Unit_instance,
  ArrayList3it5z8td81qkl as ArrayList,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString30pk9tzaqopn as toString_0,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {}
class RequestContext {
  constructor(initialClazz) {
    this.p7r_1 = initialClazz;
  }
  toString() {
    return 'RequestContext(initialClazz=' + toString(this.p7r_1) + ')';
  }
  hashCode() {
    return this.p7r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestContext))
      return false;
    var tmp0_other_with_cast = other instanceof RequestContext ? other : THROW_CCE();
    if (!this.p7r_1.equals(tmp0_other_with_cast.p7r_1))
      return false;
    return true;
  }
}
class NotMappedException extends RuntimeException {
  static x7r(clazz, requestedByClass, ctx, msg) {
    msg = msg === VOID ? 'Not mapped ' + toString(clazz) + ' requested by ' + toString(requestedByClass) + ' in ' + ctx.toString() : msg;
    var $this = this.bb(msg);
    captureStack($this, $this.w7r_1);
    $this.s7r_1 = clazz;
    $this.t7r_1 = requestedByClass;
    $this.u7r_1 = ctx;
    $this.v7r_1 = msg;
    return $this;
  }
}
class Injector {
  constructor(parent, level) {
    parent = parent === VOID ? null : parent;
    level = level === VOID ? 0 : level;
    this.y7r_1 = parent;
    this.z7r_1 = level;
    this.a7s_1 = null;
    this.b7s_1 = LinkedHashMap.wc();
    var tmp = this;
    var tmp3_safe_receiver = this.y7r_1;
    var tmp0_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.c7s_1;
    tmp.c7s_1 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    this.e7s(getKClass(Injector), this);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.d7s_1 = ArrayList.z();
  }
  f7s() {
    var tmp0_elvis_lhs = this.a7s_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp4_safe_receiver = this.y7r_1;
      tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.a7s_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  g7s() {
    return new Injector(this, this.z7r_1 + 1 | 0);
  }
  e7s(clazz, instance) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapInstance.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.b7s_1;
    var value = new InstanceObjectProvider(instance);
    this_0.k3(clazz, value);
    return this;
  }
  h7s(clazz, gen) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapSingleton.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.b7s_1;
    var value = new SingletonObjectProvider(gen);
    this_0.k3(clazz, value);
    return this;
  }
  i7s(clazz, gen) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapPrototype.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.b7s_1;
    var value = new PrototypeObjectProvider(gen);
    this_0.k3(clazz, value);
    return this;
  }
  j7s(clazz, ctx) {
    var tmp0_elvis_lhs = this.b7s_1.e3(clazz);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp7_safe_receiver = this.y7r_1;
      tmp = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.j7s(clazz, ctx);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp8_safe_receiver = this.f7s();
      var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver(clazz, ctx);
      var tmp_1;
      if (tmp9_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.inject.Injector.getProviderOrNull.<anonymous>' call
        // Inline function 'kotlin.collections.set' call
        this.b7s_1.k3(clazz, tmp9_safe_receiver);
        tmp_1 = tmp9_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp_2 = tmp_0;
    return (tmp_2 == null ? true : isInterface(tmp_2, ObjectProvider)) ? tmp_2 : null;
  }
  k7s(clazz, ctx) {
    var tmp0_elvis_lhs = this.j7s(clazz, ctx);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NotMappedException.x7r(clazz, ctx.p7r_1, ctx, "Class '" + toString(clazz) + "' doesn't have constructors " + ctx.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  l7s(clazz, ctx) {
    return this.k7s(clazz, ctx).m7s(this);
  }
  n7s(clazz, ctx, $super) {
    ctx = ctx === VOID ? new RequestContext(clazz) : ctx;
    return $super === VOID ? this.l7s(clazz, ctx) : $super.l7s.call(this, clazz, ctx);
  }
  toString() {
    return 'Injector(level=' + this.z7r_1 + ')';
  }
  o7s(instance) {
    if (!(instance == null) ? isInterface(instance, InjectorDependency) : false) {
      instance.p7s(this);
    }
    if (!(instance == null) ? isInterface(instance, InjectorDestructor) : false) {
      this.d7s_1.h(instance);
    }
    return instance;
  }
  q7s() {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.b7s_1.u1().b1();
    while (_iterator__ex2g4s.c1()) {
      var pair = _iterator__ex2g4s.d1();
      pair.w1().q7s();
    }
    var _iterator__ex2g4s_0 = this.d7s_1.b1();
    while (_iterator__ex2g4s_0.c1()) {
      var deinit = _iterator__ex2g4s_0.d1();
      deinit.q7s();
    }
    this.d7s_1.h3();
  }
}
class InjectorDependency {}
class ObjectProvider {}
class InstanceObjectProvider {
  constructor(instance) {
    this.r7s_1 = instance;
  }
  m7s(injector) {
    return this.r7s_1;
  }
  q7s() {
    var tmp = this.r7s_1;
    var tmp1_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.q7s();
    }
  }
  toString() {
    return 'InstanceObjectProvider(' + toString_0(this.r7s_1) + ')';
  }
}
class SingletonObjectProvider {
  constructor(generator) {
    this.s7s_1 = generator;
    this.t7s_1 = null;
  }
  m7s(injector) {
    if (this.t7s_1 == null)
      this.t7s_1 = injector.o7s(this.s7s_1(injector));
    return ensureNotNull(this.t7s_1);
  }
  q7s() {
    var tmp = this.t7s_1;
    var tmp0_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.q7s();
    }
  }
  toString() {
    return 'SingletonObjectProvider(' + toString_0(this.t7s_1) + ')';
  }
}
class PrototypeObjectProvider {
  constructor(generator) {
    this.u7s_1 = generator;
  }
  m7s(injector) {
    return injector.o7s(this.u7s_1(injector));
  }
  q7s() {
    return Unit_instance;
  }
  toString() {
    return 'PrototypeObjectProvider()';
  }
}
class InjectorDestructor {}
class Companion_0 {}
class InjectorContext {
  constructor(injector) {
    this.v7s_1 = injector;
  }
  v1() {
    return Companion_instance_0;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function injector($completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp11_safe_receiver = $completion.hd().ud(Companion_instance_0);
  var tmp0_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.v7s_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Injector not in the context, please call withInjector function';
    throw IllegalStateException.h5(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(RequestContext, 'RequestContext');
initMetadataForClass(NotMappedException, 'NotMappedException');
initMetadataForClass(Injector, 'Injector', Injector);
initMetadataForInterface(InjectorDependency, 'InjectorDependency');
initMetadataForInterface(ObjectProvider, 'ObjectProvider');
initMetadataForClass(InstanceObjectProvider, 'InstanceObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(SingletonObjectProvider, 'SingletonObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(PrototypeObjectProvider, 'PrototypeObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForInterface(InjectorDestructor, 'InjectorDestructor');
initMetadataForCompanion(Companion_0);
protoOf(InjectorContext).ud = get;
protoOf(InjectorContext).do = fold;
protoOf(InjectorContext).co = minusKey;
protoOf(InjectorContext).eo = plus;
initMetadataForClass(InjectorContext, 'InjectorContext', VOID, VOID, [Element]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  injector as injectorznx5rgygah7n,
  InjectorContext as InjectorContextps0ngmjb9onz,
  InjectorDependency as InjectorDependency2f8dsqe1kn3nn,
  Injector as Injectorxjyp19tp5mfu,
};
//endregion
